<template>
  <v-row class="background">
    <v-col cols="9">
      <custom-chart-renderer>
        <bar-chart
          :chartData="chartDataMonth"
          :options="optionsMonth"
          :autoRerender="false"
          :displayed="displayed"
        />
      </custom-chart-renderer>
    </v-col>
    <v-col cols="3">
      <custom-chart-renderer>
        <bar-chart
          :chartData="chartDataAverage"
          :options="optionsAverage"
          :autoRerender="false"
          :displayed="displayed"
        />
      </custom-chart-renderer>
    </v-col>
  </v-row>
</template>

<script>
import CustomChartRenderer from '@/components/graphs/CustomChartRenderer';
import BarChart from '@/components/graphs/BarChart';
import { monthLabels, showColor } from './ReadingsUtils';

export default {
  name: 'ChartByMonth',
  components: {
    CustomChartRenderer,
    BarChart,
  },
  props: {
    resultSetByMonth: { type: Array, required: false },
    chartDataMonth: { type: Object, required: true },
    chartDataAverage: { type: Object, required: true },
    graph: { type: Number, required: true },
    displayed: { type: Boolean, required: false },
  },
  methods: {
    showColor,
  },
  computed: {
    gridColor() {
      return this.$vuetify.theme.isDark ? '#3E414A' : '#DCDCDC';
    },
    optionsMonth() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          labels: {
            fontColor: this.showColor('main'),
            filter(legendItem) {
              return (
                legendItem.text !== 'indic' && legendItem.text !== 'indicBorder'
              );
            },
          },
        },
        tooltips: {
          callbacks: {
            title(items) {
              const month = monthLabels.find((el) => el.id === items[0].xLabel);
              return month ? month.name : '';
            },
          },
        },
        scales: {
          xAxes: [
            {
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
            },
          ],
          yAxes: [
            {
              id: 'yLeft1',
              position: 'left',
              display: this.graph === 1,
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
              scaleLabel: {
                display: true,
                labelString: 'NC par DJ (MWh (PCI)/ DJ)',
                fontColor: this.showColor('main'),
              },
            },
            {
              id: 'yLeft2',
              position: 'left',
              display: this.graph !== 1,
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
              scaleLabel: {
                display: true,
                labelString: 'ECS par jour (m3)',
                fontColor: this.showColor('main'),
              },
            },
            {
              id: 'yRight1',
              position: 'right',
              display: this.graph === 1,
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
              scaleLabel: {
                display: true,
                labelString: 'Degrés jours',
                fontColor: this.showColor('main'),
              },
            },
            {
              id: 'yRight2',
              position: 'right',
              display: this.graph !== 1,
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
              scaleLabel: {
                display: true,
                labelString: 'q réel',
                fontColor: this.showColor('main'),
              },
            },
          ],
        },
      };
    },
    optionsAverage() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          labels: {
            fontColor: this.showColor('main'),
            filter(legendItem) {
              return (
                legendItem.text !== 'indic' && legendItem.text !== 'indicBorder'
              );
            },
          },
        },
        tooltips: {},
        scales: {
          xAxes: [
            {
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
            },
          ],
          yAxes: [
            {
              id: 'yLeft1',
              position: 'left',
              ticks: { fontColor: this.showColor('main') },
              gridLines: { color: this.gridColor },
              scaleLabel: {
                display: true,
                labelString:
                  this.graph === 1
                    ? 'NC par DJ (MWh (PCI)/ DJ)'
                    : 'ECS par jour (m3)',
                fontColor: this.showColor('main'),
              },
            },
          ],
        },
      };
    },
  },
};
</script>
